import {useTranslation} from 'react-i18next'
import {Card} from 'reactstrap'

import Loader from '../../../../../Components/Common/Loader'
import {MeasurementImage} from './measurement-image/MeasurementImage'
import {MeasurementsTable} from './measurements-table/MeasurementsTable'

export const MeasureTab = ({isLoading}) => {
  const {t} = useTranslation()

  return (
    <Card className="card-form p-3 pb-0 mb-5">
      {isLoading ? (
        <div className="pb-3">
          <Loader />
        </div>
      ) : (
        <>
          <div className="title heading_1 mt-2 pb-3">
            {t('MEASUREMENT_INFO')}
          </div>
          <div className="row g-1">
            <div className="col-xl-6 pb-3 px-3">
              <MeasurementsTable />
            </div>
            <div className="col-xl-6 measure-tab-central-border pb-3 px-3">
              <MeasurementImage />
            </div>
          </div>
        </>
      )}
    </Card>
  )
}
